<template>
  <span class="po-display" :class="classes">{{ label }}</span>
</template>
<script>

import _ from 'lodash'

export default {
  name: 'PoDisplay',
  props: {
    value: [String, Object, Boolean, Array],
    emptyLabelKey: { type: String, default: 'general.notSet' }
  },
  computed: {
    classes () {
      return _.isUndefined(this.name) ? 'wo-u-color--light' : undefined
    },
    name () {
      return this.getDisplayName(this.value)
    },
    label () {
      return this.name || this.$t(this.emptyLabelKey)
    }
  },
  methods: {
    getDisplayName (value) {
      let result = value
      if (_.isArray(value)) {
        result = _.join(_.map(value, this.getDisplayName), ', ')
      } else if (_.isObject(value)) {
        result = value.name || value.display_name || value.label || (value.labelKey && this.$t(value.labelKey))
      } else if (_.isBoolean(value)) {
        result = this.$t(value ? 'general.yes' : 'general.no')
      }
      return result
    }
  }
}
</script>
<style lang="scss">
.wo-badge+.po-display {
  padding-left: 1em;
}
</style>
